import { createFileRoute } from "@tanstack/react-router";
import { ImportacoesPage } from "@/pages/ImportacoesPage";

export const Route = createFileRoute("/importacoes/")({
  head: () => ({ meta: [{ title: "Importações — AXIS Comprovantes" }] }),
  component: ImportacoesPage,
});
